<div
  class="flex rounded-sm border-2"
  [class]="disabled() ? 'border-transparent' : 'border-surface-300 bg-white'"
  [animate.enter]="disabled() ? '' : 'anim-pop-in'"
>
  <ng-content></ng-content>
</div>
